import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateJustificationActions } from "store/ducks/settings/justifications";

export function* updateJustificationRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/justifications/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateJustificationActions.success(data));
    notify("success", "Justificativa atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateJustificationActions.failure(errorMessage));
  }
}
